import Banner from '../../components/Banner'
import CarrosselHome from '../../components/CarrosselHome'

export default function Home() {
  return (
    <div className="container_global">
      <Banner />
      <CarrosselHome />
    </div>
  )
}
